const authReducer = (
  state = {
    authData: null,
    loading: false,
    error: false,
    updateLoading: false,
    isLogin: false,
  },

  action
) => {
  switch (action.type) {
    case "AUTH_START":
      return { ...state, loading: true, error: false };
    case "AUTH_SUCCESS":
      return {
        ...state,
        authData: action.data,
        loading: false,
        error: false,
        isLogin: true,
      };

    case "AUTH_FAIL":
      return { ...state, loading: false, error: true };
    case "UPDATING_START":
      return { ...state, updateLoading: true, error: false };
    case "UPDATING_SUCCESS":
      return {
        ...state,
        authData: action.data,
        updateLoading: false,
        error: false,
      };

    case "UPDATING_FAIL":
      return { ...state, updateLoading: true, error: true };

    case "LOG_OUT":
      localStorage.removeItem("store"); // Remove only Redux store data
      return {
        ...state,
        authData: null,
        loading: false,
        error: false,
        updateLoading: false,
        isLogin: false,
      };
    case "DELETE_USER":
      localStorage.removeItem("store");
      return {
        ...state,
        authData: null,
        loading: false,
        error: false,
        updateLoading: false,
        isLogin: false,
      };

    default:
      return state;
  }
};

export default authReducer;
